import React from "react";
import { useNavigate } from "react-router-dom";

function ViewLeadMenu(props) {
  const history = useNavigate();

  return (
    <p
      style={{
        cursor: "pointer",
        color: "#00b1b1",
      }}
      onClick={() => {
        history(
          `/leadManagementDashboard/view-lead/${props.row?.original?.leadId}`
        );
      }}
      key={props.index}
    >
      {props?.block?.name === "VIEW_LEAD_DETAILS" && "View Details"}
    </p>
  );
}

export default ViewLeadMenu;
